export default __webpack_public_path__ + "static/media/play.57920cc8.svg";